// 默认交易所常量
export const COMMON_SZ = "SZ"; // 深交所相关常量
export const COMMON_SH = "SH"; // 上交所相关常量
export const COMMON_HK = "HK"; // 港交所相关常量
export const COMMON_US = "US"; // 美交所相关常量
